import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Delete } from "../../assets/icons/delete.svg";
import styles from "./ModalNewClass.module.scss";
import { notifyError, notifyInfo } from "../../utils/notify";
import { Input, Modal, SelectInput } from "../../components";

import { selectTeachers } from "../../store/slices/teacher/slice";
import { fetchTeachers } from "../../store/slices/teacher/asyncThunks";

import { createClass, editClass } from "../../store/slices/class/asyncThunks";
import {
  selectCreateClassPending,
  selectEditClassPending,
} from "../../store/slices/class/slice";

const ModalNewClass = ({ modalRef, selectedClass, setSelectedClass }) => {
  const dispatch = useDispatch();
  const { data } = useSelector(selectTeachers);
  const editClassPending = useSelector(selectEditClassPending);
  const createClassPending = useSelector(selectCreateClassPending);

  const [className, setClassName] = useState("");

  const [selectedTeachers, setSelectedTeachers] = useState([]);

  const addTeacher = useCallback((teacher) => {
    if (teacher.id !== undefined) {
      setSelectedTeachers((oldArray) => [...new Set([...oldArray, teacher])]);
    }
  }, []);

  useEffect(() => {
    if (selectedClass) {
      setClassName(selectedClass.name);
      //   setSubject("");
      setSelectedTeachers([]);
      data.forEach((teacher) => {
        if (selectedClass.teachers) {
          selectedClass.teachers.forEach((selectedTeacher) => {
            if (teacher.id === selectedTeacher.userId) {
              addTeacher(teacher);
            }
          });
        }
      });
    } else {
      resetForm();
    }
  }, [selectedClass, data, addTeacher]);

  const resetForm = () => {
    setClassName("");
    setSelectedTeachers([]);
  };

  useEffect(() => {
    dispatch(fetchTeachers({}));
  }, [dispatch]);

  const setClass = () => {
    if (selectedClass) {
      dispatch(
        editClass({
          classId: selectedClass.classId,
          name: className,
          teachers: selectedTeachers.map((teacher) => teacher.id),
        })
      ).then((promise) => {
        if (promise.type.includes("fulfilled")) {
          notifyInfo("Successfully edited class");
          modalRef.current.hide();
        } else {
          notifyError(promise.error.message);
        }
      });
    } else {
      dispatch(
        createClass({
          name: className,
          teachers: selectedTeachers.map((teacher) => teacher.id),
        })
      ).then((promise) => {
        if (promise.type.includes("fulfilled")) {
          notifyInfo("Successfully created class");
          modalRef.current.hide();
        } else {
          notifyError(promise.error.message);
        }
      });
    }
  };

  const deleteSelectedTeacher = (teacherId) => {
    if (teacherId !== undefined) {
      setSelectedTeachers((oldArray) =>
        oldArray.filter((teacher) => teacher.id !== teacherId)
      );
    }
  };

  const btnDisabled = useMemo(() => {
    return !selectedTeachers.length || !className.trim();
  }, [selectedTeachers, className]);

  return (
    <Modal
      ref={modalRef}
      title="New Class"
      buttonOkText={selectedClass ? "EDIT CLASS" : "ADD CLASS"}
      buttonCloseText="CANCEL"
      buttonOkOnClick={setClass}
      buttonCloseOnClick={() => modalRef.current.hide()}
      onClose={() => {
        modalRef.current.hide();
        setSelectedClass(null);
      }}
      modalStyle={styles.modalContent}
      pendingAction={editClassPending || createClassPending}
      buttonOkDisabled={btnDisabled}
    >
      <div style={{ flex: 1 }}>
        <Input
          placeholder="Class Name"
          className={styles.inputMarginBottom}
          value={className}
          onChange={(event) => setClassName(event)}
        ></Input>
        <h2 className={styles.modalH2}>Teacher</h2>
        <SelectInput
          id="selectInputSchool"
          label="Select teachers"
          options={data}
          currentValue={{ name: "" }}
          setOption={addTeacher}
          removeSelect
        />
        <div>
          {selectedTeachers &&
            selectedTeachers.length > 0 &&
            selectedTeachers.map((teacher) => {
              return (
                teacher && (
                  <div key={teacher.id} className={styles.selectedTeacher}>
                    <div>{teacher.name}</div>
                    <Delete
                      style={{ transform: "scale(0.5)", cursor: "pointer" }}
                      onClick={() => deleteSelectedTeacher(teacher.id)}
                    />
                  </div>
                )
              );
            })}
        </div>
      </div>
    </Modal>
  );
};

export default ModalNewClass;
